import React from "react";
import { Col, Form, Row } from "antd";
import ModalComponent from "../../../biblio/Modal/ModalComponent";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../apis/store";
import {
  getAllUniversitiesScholarship,
  getAllSchoolScholarship,
} from "../../../apis/actions/scholarship.actions";
import { addCommitmentAttachment } from "../../../apis/actions/scholarship.actions";
import UploadInput from "../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../components/utils/utils";
interface Props {
  scholarship: any;
  type: "school" | "university";
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible : boolean
}

const AddCommitmentModal = ({
  scholarship,
  setIsModalVisible,
  type,
  isModalVisible,
}: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();

  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          graduation_certificate_ids: [imageData],
        });
        form.validateFields(["commitment_attachment_ids"]);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };
  const onFinish = async () => {
    try {
        await form.validateFields();

      const commitment_attachment_ids = form.getFieldValue(
        "graduation_certificate_ids"
      );
      console.log(commitment_attachment_ids);
      const commitmentData = {
        scholarship_application_id: scholarship.id,
        commitment_attachment_ids: commitment_attachment_ids,
      };

      dispatch(addCommitmentAttachment(commitmentData)).then((result: any) => {
        const response = result?.payload?.data?.result;
        console.log(response);
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisible(false);
          try {
            if (type === "school") {
              dispatch(getAllSchoolScholarship({limit : 8 , page : 1}));
            } else {
              dispatch(getAllUniversitiesScholarship({limit : 8 , page : 1}));
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          showNotitfication(response?.message, "error");
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
          <ModalComponent
        destroyOnClose
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={500}
        modalStyle={{ top: 200 }}
      >
      <Row justify={"center"}>
        <p className="takaful--confirm-logout">إرفاق ميثاق الإلتزام </p>
      </Row>
      <Form form={form}>
      <Row
          gutter={16}
          justify={"center"}
          style={{ paddingTop: "2rem" }}
          className={`takaful--content-profile-box1`}
        >
          <Col
            xxl={24}
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="commitment_attachment_ids"
              label="مرفق ميثاق الإلتزام"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <UploadInput
                accept="*"
                text="مرفق ميثاق الإلتزام"
                icon={<UploadOutlined />}
                multiple={false}
                maxCount={1}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          justify={"end"}
          dir="rtl"
          style={{ width: "100%", paddingTop: "1rem" }}
        >
          <PrimaryButton onClick={onFinish} title="إرسال" />
        </Row>
      </Form>
      </ModalComponent>
    </>
  );
};

export default AddCommitmentModal;
